/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetPagedArtifactPageQueryResponse, ArtifactsControllerGetPagedArtifactPagePathParams, ArtifactsControllerGetPagedArtifactPage400, ArtifactsControllerGetPagedArtifactPage404 } from "../../models/documentArtifactsController/ArtifactsControllerGetPagedArtifactPage";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerGetPagedArtifactPage } from "../../clients/document-artifactsService/artifactsControllerGetPagedArtifactPage";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerGetPagedArtifactPageQueryKey = (documentId: ArtifactsControllerGetPagedArtifactPagePathParams["documentId"], renditionId: ArtifactsControllerGetPagedArtifactPagePathParams["renditionId"], artifactId: ArtifactsControllerGetPagedArtifactPagePathParams["artifactId"], page: ArtifactsControllerGetPagedArtifactPagePathParams["page"]) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/pages/:page',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId,
    page: page
  }
}] as const;
export type ArtifactsControllerGetPagedArtifactPageQueryKey = ReturnType<typeof artifactsControllerGetPagedArtifactPageQueryKey>;
export function artifactsControllerGetPagedArtifactPageQueryOptions(documentId: ArtifactsControllerGetPagedArtifactPagePathParams["documentId"], renditionId: ArtifactsControllerGetPagedArtifactPagePathParams["renditionId"], artifactId: ArtifactsControllerGetPagedArtifactPagePathParams["artifactId"], page: ArtifactsControllerGetPagedArtifactPagePathParams["page"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerGetPagedArtifactPageQueryKey(documentId, renditionId, artifactId, page);
  return queryOptions<ArtifactsControllerGetPagedArtifactPageQueryResponse, ResponseErrorConfig<ArtifactsControllerGetPagedArtifactPage400 | ArtifactsControllerGetPagedArtifactPage404>, ArtifactsControllerGetPagedArtifactPageQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId && page),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerGetPagedArtifactPage(documentId, renditionId, artifactId, page, config);
    }
  });
}

/**
 * @description Reads one page of a page-per-line artifact (PDF native, fused content) without downloading the whole object
 * @summary Get one page of a paged artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/pages/:page}
 */
export function useArtifactsControllerGetPagedArtifactPage<TData = ArtifactsControllerGetPagedArtifactPageQueryResponse, TQueryData = ArtifactsControllerGetPagedArtifactPageQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerGetPagedArtifactPageQueryKey>(documentId: ArtifactsControllerGetPagedArtifactPagePathParams["documentId"], renditionId: ArtifactsControllerGetPagedArtifactPagePathParams["renditionId"], artifactId: ArtifactsControllerGetPagedArtifactPagePathParams["artifactId"], page: ArtifactsControllerGetPagedArtifactPagePathParams["page"], options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerGetPagedArtifactPageQueryResponse, ResponseErrorConfig<ArtifactsControllerGetPagedArtifactPage400 | ArtifactsControllerGetPagedArtifactPage404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerGetPagedArtifactPageQueryKey(documentId, renditionId, artifactId, page);
  const query = useQuery({
    ...artifactsControllerGetPagedArtifactPageQueryOptions(documentId, renditionId, artifactId, page, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerGetPagedArtifactPage400 | ArtifactsControllerGetPagedArtifactPage404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}